import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../services/common.service';
import { Router, NavigationExtras } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { DecimalFormatterPipe } from '../pipes/decimal-formatter.pipe';

@Component({
    selector: 'app-item-details-history',
    templateUrl: './item-details-history.component.html',
    styleUrls: ['./item-details-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, DecimalFormatterPipe]
})
export class ItemDetailsHistoryComponent implements OnInit {

  lists: any;
  data: any;
  in: string;
  actualQuantity: string;
  finalQuantity: string;
  added: string;
  subtracted: string;

  constructor(public _cs: CommonService, private router: Router, private _ts: TranslateService) { }

  ngOnInit() {
    this.added = this._ts.instant('common.added');
    this.subtracted = this._ts.instant('common.subtracted');
    this.in = this._ts.instant('common.in');
    this.actualQuantity = this._ts.instant('common.actualQuantity');
    this.finalQuantity = this._ts.instant('common.finalQuantity');
    this.lists = this._cs.historyDetails.noMathHistory;
  this._cs.showAppHeaderChange.next(false);
  this._cs.fromDetailSection = true;
  this.data = this._cs.historyDetails;
  this._cs.titleOptions = {
    'back': true,
    'pageTitle': this.data ? this.data.itemName : '',
    'backFunction': this.backClick
    };
  this._cs.component = this;
}
backClick(event, _this) {
  _this.navigateBack();
 }
 navigateBack() {
  this._cs.noMathBack = true;
  this._cs.addQuantity = false;
  const pop = this._cs.routeStack.pop();
  if (pop.split('?').length > 1) {
  const url = this._cs.generateParams(pop);
  url.queryParams.routedFrom = 'fromNoMath';
  this.router.navigate([pop.split('?')[0]], url);
  } else {
    const params = {};
    const navigationExtras: NavigationExtras = {
      queryParams: params
    };
    navigationExtras.queryParams.routedFrom = 'fromNoMath';
    this.router.navigate([pop]);
  }
}



}
